
import React, { useState } from "react"
import * as Constants from '../../constants/urls';
import "../AnbarGardani/AnbarGardaniStyle.css";
import axios from "axios";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

export default function ItemList(props) {

    const [cookies, setCookie, removeCookie] = useCookies();

    function submitHandle(e) {
        e.preventDefault();
        let input = e.target.elements;
        let formData = new FormData();
        formData.append("entryStock", input.entryStock.value);
        formData.append("masrafiStock", input.masrafiStock.value);
        formData.append("depackStock", input.depackStock.value);
        formData.append("cartonStock", input.cartonStock.value);
        formData.append("productedStock", input.productedStock.value);
        formData.append("productId", input.productId.value);
        formData.append("productionStock", input.productionStock.value);


        if (input.stock) {
            let packCount = input.stock.length ?? 1;
            if (packCount > 1) {
                for (let i = 0; i < packCount; i++) {
                    let packId = input.stock[i].attributes.packId.value;
                    formData.append("stock[" + packId + "]", input.stock[i].value);

                }
            }
            else {
                let packId = input.stock.attributes.packId.value;
                formData.append("stock[" + packId + "]", input.stock.value);

            }
        }

        const url = Constants.apiUrl + "/api/conflict/product/fix";
        axios
            .post(
                url,
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                console.log(r);
                toast.success("عملیات با موفقیت انجام شد .")
                props.renew();
            })
            .catch((e) => {
                if (e.response.status == 403) {
                    toast.warning("شما دسترسی انجام این کار رو ندارید !.")
                }
                toast.error("  متاسفانه خطایی در انجام عملیات پیش امد")

            });
    }

    return (
        <React.Fragment>
            <div className="row py-4 px-5 my-3 border text-center anbarGardaniProductRow" style={{ background: "rgba(0, 0, 0, 0.04)", direction: "rtl", display: "flex", alignItems: "center", minHeight: "100px" }}>

                <div className=" col-sm-2  p-0">
                    <a target="_blank" href={Constants.oldAdminUrl + "/products/update/" + props.productId}>
                        <img src={Constants.imagesBsaeUrl + '/image/resizeTest/shop/_1000x/thumb_' + props.image + '.jpg'} style={{ width: '100%', height: '100%', borderRadius: '2px', cursor: "pointer" }} productId={props.productId} productUrl={props.productUrl} onClick={props.openShortcut} />
                    </a>
                </div>
                <div className=" col-sm-6 px-1">
                    <p className="m-0">{props.name}</p>

                </div>
                <div className="col-sm-4">
                    <form onSubmit={submitHandle} >
                        <input type="hidden" name={"productId"} defaultValue={props.productId} />

                        <div className="row">

                            {props.packs.map((item) => {
                                return (
                                    <div className="col-md-6 my-1">
                                        <label>{item.label}</label>
                                        <br />
                                        <label title="لوکیشن"  >( {item.location} )</label>
                                        <br />
                                        <label title="بارکد"  >( {item.barCode} )</label>
                                        <input type="text" name={"stock"} packId={item.id} className="form-control" defaultValue={item.stock} />
                                    </div>
                                )
                            })}
                        </div>
                        <hr />

                        <div className="row">

                            <div className="col-md-6">

                                <label>انبار ورود</label>
                                <input type="text" name={"entryStock"} className="form-control  text-danger" defaultValue={props.entryStock ?? 0} />
                            </div>
                            <div className="col-md-6">

                                <label>انبار تولید</label>
                                <input type="text" name="productionStock" className="form-control  text-danger" defaultValue={props.productionStock ?? 0} />
                            </div>

                            <div className="col-md-6">

                                <label>انبار مصرفی</label>
                                <input type="text" name={"masrafiStock"} className="form-control  text-danger" defaultValue={props.masrafiStock ?? 0} />
                            </div>
                            <div className="col-md-6">
                                <label>انبار دیپک شده</label>
                                <input type="text" name="depackStock" className="form-control  text-danger" defaultValue={props.depackStock ?? 0} />
                            </div>
                            <div className="col-md-6">
                                <label>انبار تولید شده</label>
                                <input type="text" name="productedStock" className="form-control  text-danger" defaultValue={props.productedStock ?? 0} />
                            </div>
                            <div className="col-md-6">
                                <label>انبار کارتون</label>
                                <input type="text" name="cartonStock" className="form-control  text-danger" defaultValue={props.cartonStock ?? 0} />
                            </div>
                            <div className="col">
                                <hr />

                                <button className="btn btn-danger btn-block  mt-5">ذخیره</button>
                            </div>

                        </div>
                    </form>


                </div>

            </div>
            <div className="row">
                <div className="col">

                </div>
            </div>
        </React.Fragment>
    )
}

